import MuiTable, { type TableProps } from "@mui/material/Table";
import MuiTableBody, { type TableBodyProps } from "@mui/material/TableBody";
import MuiTableCell, { type TableCellProps } from "@mui/material/TableCell";
import MuiTableContainer, { type TableContainerProps } from "@mui/material/TableContainer";
import MuiTableHead, { type TableHeadProps } from "@mui/material/TableHead";
import MuiTableRow, { type TableRowProps } from "@mui/material/TableRow";
import MuiTableFooter, { type TableFooterProps } from "@mui/material/TableFooter";
import MuiTablePagination, { type TablePaginationProps } from "@mui/material/TablePagination";
import MuiTableSortLabel, { type TableSortLabelProps } from "@mui/material/TableSortLabel";

export type {
  TableProps,
  TableBodyProps,
  TableCellProps,
  TableContainerProps,
  TableHeadProps,
  TableRowProps,
  TableFooterProps,
  TablePaginationProps,
  TableSortLabelProps,
};

export function Table(props: TableProps) {
  return <MuiTable {...props} />;
}

export function TableBody(props: TableBodyProps) {
  return <MuiTableBody {...props} />;
}

export function TableCell(props: TableCellProps) {
  return <MuiTableCell {...props} />;
}

export function TableContainer(props: TableContainerProps) {
  return <MuiTableContainer {...props} />;
}

export function TableHead(props: TableHeadProps) {
  return <MuiTableHead {...props} />;
}

export function TableRow(props: TableRowProps) {
  return <MuiTableRow {...props} />;
}

export function TableFooter(props: TableFooterProps) {
  return <MuiTableFooter {...props} />;
}

export function TablePagination(props: TablePaginationProps) {
  return <MuiTablePagination {...props} />;
}

export function TableSortLabel(props: TableSortLabelProps) {
  return <MuiTableSortLabel {...props} />;
}
